"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_query_operation_1 = require("@comunica/bus-query-operation");

var asynciterator_promiseproxy_1 = require("asynciterator-promiseproxy");

var rdf_string_1 = require("rdf-string");

var rdf_terms_1 = require("rdf-terms");
/**
 * A comunica actor for handling 'quadpattern' query operations.
 */


var ActorQueryOperationQuadpattern =
/*#__PURE__*/
function (_bus_query_operation_) {
  _inherits(ActorQueryOperationQuadpattern, _bus_query_operation_);

  function ActorQueryOperationQuadpattern(args) {
    _classCallCheck(this, ActorQueryOperationQuadpattern);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorQueryOperationQuadpattern).call(this, args, 'pattern'));
  }
  /**
   * Check if a term is a variable.
   * @param {RDF.Term} term An RDF term.
   * @return {any} If the term is a variable or blank node.
   */


  _createClass(ActorQueryOperationQuadpattern, [{
    key: "getVariables",

    /**
     * Get all variables in the given pattern.
     * No duplicates are returned.
     * @param {RDF.BaseQuad} pattern A quad pattern.
     * @return {string[]} The variables in this pattern, without '?' prefix.
     */
    value: function getVariables(pattern) {
      return rdf_terms_1.uniqTerms(rdf_terms_1.getTerms(pattern).filter(ActorQueryOperationQuadpattern.isTermVariable)).map(rdf_string_1.termToString);
    }
  }, {
    key: "testOperation",
    value: function () {
      var _testOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(operation, context) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", true);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function testOperation(_x, _x2) {
        return _testOperation.apply(this, arguments);
      }

      return testOperation;
    }()
  }, {
    key: "runOperation",
    value: function () {
      var _runOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(pattern, context) {
        var result, variables, elementVariables, quadBindingsReducer, bindingsStream;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.mediatorResolveQuadPattern.mediate({
                  pattern: pattern,
                  context: context
                });

              case 2:
                result = _context3.sent;
                // Collect all variables from the pattern
                variables = this.getVariables(pattern); // Convenience datastructure for mapping quad elements to variables

                elementVariables = rdf_terms_1.reduceTerms(pattern, function (acc, term, key) {
                  if (ActorQueryOperationQuadpattern.isTermVariable(term)) {
                    acc[key] = rdf_string_1.termToString(term);
                  }

                  return acc;
                }, {});

                quadBindingsReducer = function quadBindingsReducer(acc, term, key) {
                  var variable = elementVariables[key];

                  if (variable) {
                    acc[variable] = term;
                  }

                  return acc;
                };

                bindingsStream = new asynciterator_promiseproxy_1.PromiseProxyIterator(
                /*#__PURE__*/
                _asyncToGenerator(
                /*#__PURE__*/
                _regeneratorRuntime.mark(function _callee2() {
                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          return _context2.abrupt("return", result.data.map(function (quad) {
                            return bus_query_operation_1.Bindings(rdf_terms_1.reduceTerms(quad, quadBindingsReducer, {}));
                          }, {
                            autoStart: true,
                            maxBufferSize: 128
                          }));

                        case 1:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                })));
                return _context3.abrupt("return", {
                  type: 'bindings',
                  bindingsStream: bindingsStream,
                  variables: variables,
                  metadata: result.metadata
                });

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function runOperation(_x3, _x4) {
        return _runOperation.apply(this, arguments);
      }

      return runOperation;
    }()
  }], [{
    key: "isTermVariable",
    value: function isTermVariable(term) {
      return term.termType === 'Variable';
    }
  }]);

  return ActorQueryOperationQuadpattern;
}(bus_query_operation_1.ActorQueryOperationTyped);

exports.ActorQueryOperationQuadpattern = ActorQueryOperationQuadpattern;